module.exports = function (THREE) {
  const v12888 = new THREE.Vector3();
  const v12889 = new THREE.Vector3();
  const v12890 = new THREE.Vector3();
  const v12891 = new THREE.Plane();
  const v12892 = new THREE.Line3();
  const v12893 = new THREE.Line3();
  const v12894 = new THREE.Capsule(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 0), 0);
  const v12895 = new THREE.Capsule(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 0), 0);
  this.collBounds = function (p16223, p16224, p16225, p16226, p16227, p16228) {
    return p16224 + p16227 >= p16223.minX && p16224 - p16227 <= p16223.maxX && p16226 + p16227 >= p16223.minZ && p16226 - p16227 <= p16223.maxZ && p16225 + p16228 * 2 >= p16223.minY && p16225 - p16228 <= p16223.maxY;
  };
  this.capsuleColl = function (p16229, p16230, p16231, p16232, p16233, p16234) {
    if (!this.collBounds(p16229, p16230, p16231, p16232, p16233, p16234)) {
      return null;
    }
    v12889.set(p16230, p16231, p16232);
    v12890.set(p16230, p16231 + p16234, p16232);
    v12894.set(v12889, v12890, p16233);
    let v12896;
    v12895.copy(v12894);
    if (v12896 = this.triCapsInter(v12895, p16229)) {
      v12895.translate(v12896.normal.multiplyScalar(v12896.depth));
      const v12897 = v12895.getCenter(new THREE.Vector3()).sub(v12894.getCenter(v12888));
      var v12898 = v12897.length();
      return {
        normal: v12897.normalize(),
        depth: v12898
      };
    }
    return null;
  };
  this.triCapsInter = function (p16235, p16236) {
    p16236.getPlane(v12891);
    const v12899 = v12891.distanceToPoint(p16235.start) - p16235.radius;
    const v12900 = v12891.distanceToPoint(p16235.end) - p16235.radius;
    if (v12899 > 0 && v12900 > 0 || v12899 < -p16235.radius && v12900 < -p16235.radius) {
      return false;
    }
    const v12901 = Math.abs(v12899 / (Math.abs(v12899) + Math.abs(v12900)));
    const v12902 = v12888.copy(p16235.start).lerp(p16235.end, v12901);
    if (p16236.containsPoint(v12902)) {
      return {
        normal: v12891.normal.clone(),
        point: v12902.clone(),
        depth: Math.abs(Math.min(v12899, v12900))
      };
    }
    const v12903 = p16235.radius * p16235.radius;
    const v12904 = v12892.set(p16235.start, p16235.end);
    const vA713 = [[p16236.a, p16236.b], [p16236.b, p16236.c], [p16236.c, p16236.a]];
    for (let vLN02306 = 0; vLN02306 < vA713.length; vLN02306++) {
      const v12905 = v12893.set(vA713[vLN02306][0], vA713[vLN02306][1]);
      const [v12906, v12907] = p16235.lineLineMinimumPoints(v12904, v12905);
      if (v12906.distanceToSquared(v12907) < v12903) {
        return {
          normal: v12906.clone().sub(v12907).normalize(),
          point: v12907.clone(),
          depth: p16235.radius - v12906.distanceTo(v12907)
        };
      }
    }
    return false;
  };
};